import moment from 'moment'

export const getOpsHoursAndStoreHours = (storeHour, setOpsHours, setStoreHours) => {
    const updateHours = (timeString, hours) => {
        let [hoursStr, minutesStr] = timeString.split(':')
        let hoursNum = parseInt(hoursStr)
        let minutesNum = parseInt(minutesStr)

        hoursNum += hours

        if (hoursNum < 0) {
            hoursNum += 24
        } else if (hoursNum >= 24) {
            hoursNum -= 24
        }

        let updatedTimeString = `${String(hoursNum).padStart(1, '0')}:${String(minutesNum).padStart(2, '0')}`
        return updatedTimeString
    }
    let storeStart = updateHours(storeHour.open_time, 4)
    let storeEnd = updateHours(storeHour.close_time, -2)
    setStoreHours([storeStart, storeEnd])
    let opsStart = parseInt(storeHour?.open_time?.split(':')[0])
    let opsEnd = parseInt(storeHour?.close_time?.split(':'))
    if (parseInt(opsEnd[1]) > 0) {
        opsEnd = parseInt(opsEnd[0]) + 1
    } else {
        opsEnd = parseInt(opsEnd[0])
    }
    opsEnd =
        opsEnd < opsStart || storeHour?.next_day_end
            ? parseInt(storeHour?.close_time?.split(':')[0]) + 24
            : parseInt(storeHour?.close_time?.split(':')[0])
    setOpsHours([opsStart, opsEnd])
}

export const getPdfDisplayHour = (shiftDate, dayOrDate, hour) => {
    const rawHour = hour === undefined ? undefined : parseInt(hour, 10)

    if (dayOrDate instanceof Date) {
        if (!shiftDate) {
            return dayOrDate.getHours()
        }

        const baseDate = moment(shiftDate, 'YYYY-MM-DD').startOf('day')
        const actualDate = moment(dayOrDate)
        const dayDiff = actualDate.clone().startOf('day').diff(baseDate, 'days')
        return actualDate.hour() + dayDiff * 24
    }

    if (!shiftDate || !dayOrDate) {
        return rawHour
    }

    const baseDate = moment(shiftDate, 'YYYY-MM-DD').startOf('day')
    const actualDate = moment(dayOrDate, 'YYYY-MM-DD').startOf('day').hour(rawHour || 0)
    const dayDiff = actualDate.clone().startOf('day').diff(baseDate, 'days')
    return actualDate.hour() + dayDiff * 24
}

export const getPdfStaffRequirementKey = (shiftDate, displayHour) =>
    moment(shiftDate, 'YYYY-MM-DD').startOf('day').add(displayHour, 'hours').format('D-H')

export const getPdfMissingStaffDisplayHour = (shiftDate, timeKey) => {
    if (!timeKey) {
        return undefined
    }

    const key = String(timeKey)
    if (/^\d+$/.test(key)) {
        return parseInt(key, 10)
    }

    const fullDateHour = key.match(/^(\d{4}-\d{2}-\d{2})-(\d{1,2})$/)
    if (fullDateHour) {
        return getPdfDisplayHour(shiftDate, fullDateHour[1], fullDateHour[2])
    }

    const dayHour = key.match(/^(\d{1,2})-(\d{1,2})$/)
    if (dayHour && shiftDate) {
        const baseDate = moment(shiftDate, 'YYYY-MM-DD')
        const nextDate = baseDate.clone().add(1, 'day')
        const day = parseInt(dayHour[1], 10)
        const actualDate = day === nextDate.date() ? nextDate : baseDate
        return getPdfDisplayHour(shiftDate, actualDate.format('YYYY-MM-DD'), dayHour[2])
    }

    const hour = parseInt(key.split('-').pop(), 10)
    return Number.isNaN(hour) ? undefined : hour
}

export const buildPdfHourlyPreds = (staffRequirements = [], shiftDate, missingStaffHours = {}) => {
    const preds = []
    staffRequirements.forEach(staff => {
        const { day, hour, pred_sales, customer_preds, customer_staff_required, staff_required } = staff
        const displayHour = getPdfDisplayHour(shiftDate, day, hour)
        preds[displayHour] = {
            pred_sales: customer_preds || pred_sales,
            staff_required: customer_staff_required || staff_required
        }
    })

    Object.entries(missingStaffHours || {}).forEach(([time, val]) => {
        const displayHour = getPdfMissingStaffDisplayHour(shiftDate, time)
        if (displayHour === undefined) {
            return
        }
        const missing = val > 0 ? val : 0
        preds[displayHour] = {
            ...preds[displayHour],
            missing
        }
    })

    return preds
}
